const x = {
  s: "0px 2px 4px rgba(0, 0, 0, 0.08)",
  m: "0px 4px 8px rgba(0, 0, 0, 0.16)",
  l: "0px 8px 16px rgba(0, 0, 0, 0.24)",
  xl: "0px 16px 24px rgba(0, 0, 0, 0.32)"
};
export {
  x as shadow
};
//# sourceMappingURL=shadow.es.js.map
